import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-contact-box',
    templateUrl: './contact-box.component.html',
    styleUrls: ['./contact-box.component.scss']
})

export class ContactBoxComponent implements OnInit {

    constructor() { }

    ngOnInit() {
        console.log('ContactBoxComponent init');
    }

}
